import { KeyRound, Coins, Wallet } from 'lucide-react'
import { Link } from 'react-router'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/shadcn/button'
import { usePermissions } from '@/hooks/usePermissions'
import { PermissionEntityType } from '@/api/model'

interface Props {
  onResetPassword: () => void
  onBookPoints: () => void
  walletId?: string | null
}

export function EmployeeDetailActions({ onResetPassword, onBookPoints, walletId }: Props) {
  const { t } = useTranslation('employees')
  const { userHasPermission } = usePermissions()
  const canEdit = userHasPermission(PermissionEntityType.Employees, 'Edit')
  return (
    <div className="flex items-center gap-2">
      <Button variant="outline" size="sm" onClick={onResetPassword} disabled={!canEdit}>
        <KeyRound className="size-4 mr-2" />
        {t('detail.actions.resetPassword')}
      </Button>
      {walletId && (
        <Button asChild variant="outline" size="sm">
          <Link to={`/wallet/${walletId}`}>
            <Wallet className="size-4 mr-2" />
            {t('detail.info.openWallet')}
          </Link>
        </Button>
      )}
      <Button size="sm" onClick={onBookPoints} disabled={!canEdit}>
        <Coins className="size-4 mr-2" />
        {t('detail.actions.bookPoints')}
      </Button>
    </div>
  )
}
